/* Paw collection filters: dual price slider + show-more toggle.
   Works alongside facets.js — sliders are nameless, they mirror the named
   number inputs and commit one 'input' event on release so the facets form
   fetches exactly once per drag. */
(function () {
  function initSliders(root) {
    root.querySelectorAll('[data-paw-price]').forEach(function (wrap) {
      if (wrap.dataset.pawInit) return;
      wrap.dataset.pawInit = 'true';

      var minNum = wrap.querySelector('[data-price-min]');
      var maxNum = wrap.querySelector('[data-price-max]');
      var minR = wrap.querySelector('[data-range-min]');
      var maxR = wrap.querySelector('[data-range-max]');
      var fill = wrap.querySelector('[data-range-fill]');
      if (!minNum || !maxNum || !minR || !maxR || !fill) return;

      var cap = parseFloat(minR.max) || 0;

      function paint() {
        if (!cap) return;
        var a = parseFloat(minR.value) || 0;
        var b = parseFloat(maxR.value);
        if (isNaN(b)) b = cap;
        var lo = Math.min(a, b);
        var hi = Math.max(a, b);
        fill.style.insetInlineStart = (lo / cap) * 100 + '%';
        fill.style.width = ((hi - lo) / cap) * 100 + '%';
      }

      function syncFromNumbers() {
        minR.value = parseFloat(minNum.value) || 0;
        maxR.value = maxNum.value === '' ? cap : parseFloat(maxNum.value);
        paint();
      }

      function syncNumbersSilently() {
        var lo = Math.min(parseFloat(minR.value), parseFloat(maxR.value));
        var hi = Math.max(parseFloat(minR.value), parseFloat(maxR.value));
        minNum.value = lo > 0 ? lo : '';
        maxNum.value = hi < cap ? hi : '';
      }

      [minR, maxR].forEach(function (r) {
        /* keep drag events away from the facets form (it listens for input) */
        r.addEventListener('input', function (e) {
          e.stopPropagation();
          if (r === minR && parseFloat(minR.value) > parseFloat(maxR.value)) {
            minR.value = maxR.value;
          }
          if (r === maxR && parseFloat(maxR.value) < parseFloat(minR.value)) {
            maxR.value = minR.value;
          }
          syncNumbersSilently();
          paint();
        });
        r.addEventListener('change', function (e) {
          e.stopPropagation();
          syncNumbersSilently();
          paint();
          /* one bubbling event → facets.js debounced submit */
          minNum.dispatchEvent(new Event('input', { bubbles: true }));
        });
      });

      [minNum, maxNum].forEach(function (n) {
        n.addEventListener('input', syncFromNumbers);
      });

      syncFromNumbers();
    });
  }

  function initMore() {
    var more = document.querySelector('[data-paw-more]');
    var panel = document.getElementById('FacetsWrapperDesktop');
    if (!more || !panel || more.dataset.pawInit) return;
    more.dataset.pawInit = 'true';

    more.addEventListener('click', function () {
      var expanded = panel.classList.toggle('paw-filters--expanded');
      more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var show = more.querySelector('[data-more-show]');
      var hide = more.querySelector('[data-more-hide]');
      if (show) show.hidden = expanded;
      if (hide) hide.hidden = !expanded;
    });
  }

  function boot() {
    var form = document.getElementById('FacetFiltersForm');
    if (!form) return;
    initSliders(form);
    initMore();
    /* facets.js re-renders group innerHTML after every change — re-init */
    new MutationObserver(function () {
      initSliders(form);
    }).observe(form, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
